import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import "./i18n/i18n";
import { LoginPage } from "./pages/LoginPage/LoginPage";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { FlashscanPage } from "./pages/FlashscanPage/FlashscanPage";
import { PrivateRoute } from "./router/PrivateRoute";
import { PublicRoute } from "./router/PublicRoute";
import { AuthGate } from "./router/AuthGate";
import { AuthAwareFallbackRoute } from "./router/AuthAwareFallbackRoute";
import { SalesforceCallbackPage } from "./pages/SalesforceCallbackPage/SalesforceCallbackPage";
import { StripeCallbackPage } from "./pages/StripeCallbackPage/StripeCallbackPage";
import { IntegrationsPage } from "./pages/IntegrationsPage/IntegrationsPage";
import { HubspotCallbackPage } from "./pages/HubspotCallbackPage/HubspotCallbackPage";
import { QontoCallbackPage } from "./pages/QontoCallbackPage/QontoCallbackPage";
import { CreateAccountPage } from "./pages/CreateAccountPage/CreateAccountPage";
import { ForgotPasswordPage } from "./pages/ForgotPasswordPage/ForgotPasswordPage";
import { ResetPasswordPage } from "./pages/ResetPasswordPage/ResetPasswordPage";
import { NotFoundPage } from "./pages/NotFoundPage/NotFoundPage";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route
          path="/login"
          element={
            <PublicRoute>
              <LoginPage />
            </PublicRoute>
          }
        />
        <Route
          path="/create-account"
          element={
            <PublicRoute>
              <CreateAccountPage />
            </PublicRoute>
          }
        />
        <Route
          path="/forgot-password"
          element={
            <PublicRoute>
              <ForgotPasswordPage />
            </PublicRoute>
          }
        />
        <Route
          path="/reset-password"
          element={
            <PublicRoute>
              <ResetPasswordPage />
            </PublicRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <FlashscanPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/integrations"
          element={
            <PrivateRoute>
              <IntegrationsPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/"
          element={<AuthAwareFallbackRoute authedRedirectTo="/dashboard" />}
        />
        <Route
          path="/salesforce/callback"
          element={
            <AuthGate>
              <SalesforceCallbackPage />
            </AuthGate>
          }
        />

        <Route
          path="/stripe/callback"
          element={
            <AuthGate>
              <StripeCallbackPage />
            </AuthGate>
          }
        />

        <Route
          path="/hubspot/callback"
          element={
            <AuthGate>
              <HubspotCallbackPage />
            </AuthGate>
          }
        />

        <Route
          path="/qonto/callback"
          element={
            <AuthGate>
              <QontoCallbackPage />
            </AuthGate>
          }
        />
        <Route path="/404" element={<NotFoundPage />} />
        <Route path="*" element={<AuthAwareFallbackRoute />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
);
